import Vue__default from "vue";
const nodeMap = /* @__PURE__ */ new Map();
Vue__default.directive("click-outside", {
  bind: (el, binding) => {
    const listenerFunction = (event) => {
      if (el.contains(event.target)) {
        return;
      }
      if (binding.value && typeof binding.value === "function") {
        binding.value(event);
      }
    };
    if (!nodeMap.has(el)) {
      nodeMap.set(el, []);
    }
    const nodeCallbackList = nodeMap.get(el);
    nodeCallbackList.push(listenerFunction);
    document.addEventListener("click", listenerFunction);
  },
  unbind: (el) => {
    const nodeCallbackList = nodeMap.get(el);
    nodeCallbackList.forEach((callback) => {
      document.removeEventListener("click", callback);
    });
  }
});
